// Único m.trust do bundle: só recebe SVG de sanitizeSvg e descrição de
// sanitiseDescription. Um ponto só facilita revisar o que vira HTML.
const mithrilTrust = m.trust;
export default function trustedHtml(html) {
  return mithrilTrust(html);
}
flarum.reg.add('ramon-verified', 'common/utils/trustedHtml', trustedHtml);